<template>
  <div>
    <div>
      <PinModal ref="pinModal" @pin-submitted="handlePinSubmission" />
    </div>
  </div>
</template>

<script>
import rules from '@/plugins/rules'
import PinModal from '@/components/PinModal.vue'
export default {
  props: ['toolbar', 'confirmDisabled'],
  inject: ['showMsgBox'],
  components: {
    PinModal
  },
  data: () => ({
    templatesDialogOpen: false,
    dialog: false,
    selectedUser: '',
    pincode: '',
    width: 300,
    users: [],
    scrollable: false,
    confirmDis: true,
    cashReg: {},
    rules: {
      req: rules.req()
    }
  }),
  computed: {
    pincodeValid () {
      if (this.pincode.length !== 4) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    openPinModal () {
      this.$refs.pinModal.openModal()
    },
    submit (pin) {
      console.log('PIN received in parent:', pin)
      // Do something with the submitted PIN
    },
    open (users, cashReg) {
      users.forEach(user => {
        this.users.push(user.user)
      })
      this.cashReg = cashReg
      this.dialog = true
      this.$refs.pinModal.openModal()
    },
    close () {
      this.dialog = false
    },
    userChoosed (selectedUser) {
      this.$emit('userSelectSuccess', { user: selectedUser, cashReg: this.cashReg })
      this.dialog = false
    },
    handlePinSubmission (pincode) {
      this.pincode = pincode
      this.users.forEach(user => {
        if (user.pincode !== undefined && user.pincode !== '' && user.pincode !== null && user.pincode === this.pincode) {
          this.selectedUser = user
        }
      })

      if (this.selectedUser !== undefined && this.selectedUser !== '' && this.selectedUser.id !== '') {
        this.$emit('pinLoginSuccess', { user: this.selectedUser, cashReg: this.cashReg })
      } else {
        this.showMsgBox({
          text: 'Neispravan pincode, molimo pokušajte ponovno.',
          actions: ['cancel'],
          cancelBtnText: this.$t('$vuetify.close'),
          color: 'error'
        })

        this.pincode = ''
      }
    }
  },
  mounted () {
  }
}
</script>
